import {
  SiGoogledrive,
  SiInstagram,
  SiTiktok,
  SiVimeo,
  SiYoutube,
} from "@icons-pack/react-simple-icons"
import type { ReferenceVideoPlatform } from "@nexus/contracts"
import { Icon, cn } from "@nexus/ui"

const PLATFORM_MARKS: Record<
  Exclude<ReferenceVideoPlatform, "other">,
  { Glyph: typeof SiTiktok; colorClassName: string }
> = {
  // TikTok's mark is black; the foreground token keeps it visible in dark mode.
  tiktok: { Glyph: SiTiktok, colorClassName: "text-foreground" },
  youtube: { Glyph: SiYoutube, colorClassName: "text-[#FF0000]" },
  instagram: { Glyph: SiInstagram, colorClassName: "text-[#E4405F]" },
  "google-drive": { Glyph: SiGoogledrive, colorClassName: "text-[#1FA463]" },
  vimeo: { Glyph: SiVimeo, colorClassName: "text-[#1AB7EA]" },
}

/** The platform's brand mark, or a plain link icon for any other site. */
export function ReferenceVideoPlatformMark({
  platform,
  className,
}: {
  platform: ReferenceVideoPlatform | null
  className?: string
}) {
  if (!platform || platform === "other") {
    return <Icon name="link" size="sm" className={cn("shrink-0 text-muted-foreground", className)} />
  }
  const { Glyph, colorClassName } = PLATFORM_MARKS[platform]
  // Decorative next to the platform name, so no `<title>` repeating it.
  return <Glyph aria-hidden title="" size={14} className={cn("shrink-0", colorClassName, className)} />
}
